import {
  addProfile,
  userSignIn,
} from "../actions/index";
import { fetchUserNotifications } from "./notificationApi";
import { openSocketConnection } from '../../socket';
import { fetchAllContent } from "./contentApi";

export const fetchProfile = () => (dispatch, getState) => {
  const token = window.localStorage.getItem("token");
  var myHeaders = {
    authorization: token,
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch("https://recruitingmonk-v2.azurewebsites.net/current", requestOptions)
    .then(
      (response) => {
        if (response.ok) {
          console.log(response);
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((data) => {
      dispatch(addProfile(data));
      dispatch(userSignIn(token));
      openSocketConnection(dispatch);
      dispatch(fetchAllContent());
      dispatch(fetchUserQuizDetails());
      dispatch(fetchUserNotifications());
    })
    .catch(console.log);
};

export const fetchUserQuizDetails = () => (dispatch, getState) => {
  if (!getState().authUser.isAuthenticated) return;
  const token = window.localStorage.getItem("token");
  return fetch(`https://recruitingmonk-v2.azurewebsites.net/quiz/${getState().info.info.uid}`, {
    method: "GET",
    headers: { "Content-Type": "application/json", Authorization: token },
  })
    .then(
      (response) => {
        if (response.ok) {
          console.log(response);
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((data) => {
      dispatch(addProfile(data));
    })
    .catch((error) => console.log(error));
};
